import React, { FC } from 'react';
import { Button } from 'antd';
import styles from '../AnnotationForm.module.scss';
import { COMMENTS_TAB_KEY } from '../Helpers';
import { UseHaveAnyPermissions } from '../../../../../Auth/UseHaveAnyPermissions';
import { Permissions } from '../../../../../shared/models/permissions.enum';

type Props = {
  saveDisabled: boolean;
  selectedTabKey: string;
  showAskForAssessment: boolean;
  isLoading: boolean;
  showQAReviewButton: boolean;
  onSubmit: () => void;
  cancelAnnotationCreation: () => void;
  askForAssessment: () => void;
  onSetQAReviewPassed: () => void;
};

export const AnnotationFormFooter: FC<Props> = ({
  saveDisabled,
  selectedTabKey,
  showAskForAssessment,
  isLoading,
  showQAReviewButton,
  onSubmit,
  cancelAnnotationCreation,
  askForAssessment,
  onSetQAReviewPassed
}) => {
  const canSetQAreviewStatusPermission = UseHaveAnyPermissions([Permissions.AnnotationManager_QAReview]);

  const buttonName = canSetQAreviewStatusPermission && showQAReviewButton ? 'QA Issue fixed' : 'Save';

  return (
    <div className={selectedTabKey === COMMENTS_TAB_KEY ? styles.annotationFormFooterHide : styles.annotationFormFooter}>
      {showAskForAssessment && (
        <Button className={styles.footerButtonMargins} type='link' onClick={askForAssessment}>
          Ask for assessment
        </Button>
      )}
      <div>
        {canSetQAreviewStatusPermission && showQAReviewButton && (
          <Button
            loading={isLoading}
            className={styles.footerButtonMargins}
            disabled={isLoading}
            key='qareviewpassed'
            htmlType='submit'
            onClick={onSetQAReviewPassed}
          >
            QA review passed
          </Button>
        )}
        <Button
          className={styles.footerButtonMargins}
          loading={isLoading}
          disabled={saveDisabled || isLoading}
          key='submit'
          htmlType='submit'
          onClick={onSubmit}
        >
          {buttonName}
        </Button>
        <Button disabled={isLoading} style={{ marginRight: '5px' }} key='back' onClick={cancelAnnotationCreation}>
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default AnnotationFormFooter;
